import { store } from "src/configureStore";
import { HTTP_METHODS } from "src/constants";
import { makeCall } from "src/helpers";
import rootRoutes from "src/routes"

const FETCH_ENDPOINT = "/api/DCI_list";

const FETCH_ENDPOINT2 = "/api/DCI_list?id=:param";

export const formatFiltredResponse = (items,params) =>
  {
    return items.map((item) => ({
      // label: isRLTLang() ? item.valueAr : item.valueFr,
      label : item.vaccinAbr,
      value: item.id,
      ...item,
    }))
    .filter(item =>  item.ageRangeArray.includes(Number(params)))
  }

  export const formatResponse = (items, dcis = []) => {
    const mappedItems = items.map((item) => ({
      // label: isRLTLang() ? item.valueAr : item.valueFr,
      label : item.vaccinAbr,
      value: item.codeDci,
      ...item,
    }));
    
    // Filter by dcis if provided
    if (dcis.length > 0) {
      return mappedItems.filter(item => dcis.includes(item.codeDci));
    }
    
    return mappedItems;
  };

  export const vaccinationScolaireLibelletUIHelper = (callback, params, filter = false, dcis = []) => {
    const { token, headerTokenType, audience } = store.getState().common.auth || {};
    const tokenType = headerTokenType ? headerTokenType : 'Bearer';
    
    // console.log('filter======>', filter, 'dcis======>', dcis);
    
    if (!params && filter === true) {
      callback([]);
      return;
    }
    
    // Don't call API if dcis is empty and filter is false
    if (filter === false && dcis.length === 0) {
      callback([]);
      return;
    }

    return new Promise((resolve, reject) =>
      makeCall(HTTP_METHODS.GET, FETCH_ENDPOINT, { _pagination: false }, { Authorization: `${tokenType} ${token}`, audience: `${audience}` }, {...filter})
        .then((resp) => resolve(callback(params ? formatFiltredResponse(resp.data, params) : formatResponse(resp.data, dcis))))
        .catch((err) => { 
          if (err.response && err.response.status === 401) {
            window.location.href = rootRoutes.logout.path;
            return;
          }
          return reject(callback([]));
        })
    );
  };
